// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2C8qN","col":"styles_col__39ECy"};